import FigmaDimensionsIcon from './FigmaDimensionsIcon';

interface Properties {
  width?: number;
  height?: number;
}

const DimensionsIcon = ({ width = 16, height = 16 }: Properties) => {
  return <FigmaDimensionsIcon width={width} height={height} color='#121826' />;
};

export default DimensionsIcon;
